import useSWR from "swr";
import { fetcher } from "./lib/fetcher";

/**
 * Hook to fetch energy partition data using SWR.
 * @param {string} locationKey - a unique identifier for the location, e.g. Sachsen_Ort_Leipzig
 * @param {string} energySource - e.g. pv (solarpower) or wp (windpower).
 * @param {string} category - e.g. Asset location (like 'Openspace') or a size category (like 'Power_0_10').
 * @param {string} smallMultipleType - Type of small multiple (e.g. 'location' or 'size').
 * @returns {{ rawData: object | null, error: Error | null, loading: boolean }} SWR-compatible result
 */
export const useFetchPartitionData = (locationKey, energySource, category, smallMultipleType) => {
  const shouldFetch = locationKey && energySource && category && smallMultipleType;
  const apiUrl = process.env.REACT_APP_API_BASE_URI;
  
  const { data, error, isValidating } = useSWR(
    shouldFetch
      ? `${apiUrl}/energy_partition_${smallMultipleType}?location_key=${locationKey}&category=${category}&source=${energySource}`
      : null,
    fetcher
  );

  return {
    rawData: data,
    error,
    loading: isValidating && !data,
  };
};
